import SmimeBccForkingMode from '../store/schema/SmimeBccForkingMode';
import SmimeViewState from '../store/schema/SmimeViewState';

export default function isSmimeMessageBccFork(smimeViewState: SmimeViewState): boolean {
    if (smimeViewState.smimeBccForkingMode) {
        const { smimeBccForkingMode } = smimeViewState;
        return (
            smimeBccForkingMode === SmimeBccForkingMode.IncludeSingleBccInEachMessage ||
            smimeBccForkingMode === SmimeBccForkingMode.IncludeAllBccInSingleMessage
        );
    } else {
        return false;
    }
}
